export default {
    top({ elementMetrics, dropElementMetrics, offset }) {
        return {
            metrics: {
                top: elementMetrics.top - dropElementMetrics.height - offset,
            },
            possibleToChange: 'x',
        };
    },
    bottom({ elementMetrics, offset }) {
        return {
            metrics: {
                top: elementMetrics.bottom + offset,
            },
            possibleToChange: 'x',
        };
    },
    left({ elementMetrics, dropElementMetrics, offset }) {
        return {
            metrics: {
                left: elementMetrics.left - dropElementMetrics.width - offset,
            },
            possibleToChange: 'y',
        };
    },
    right({ elementMetrics, offset }) {
        return {
            metrics: {
                left: elementMetrics.right + offset,
            },
            possibleToChange: 'y',
        };
    },
};
